"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../assets/PPLayout.css");
var TopBar_1 = __importDefault(require("./TopBar"));
var ToolBar_1 = __importDefault(require("./ToolBar"));
var PPLayout = function (props) {
    var _a = (0, react_1.useState)(false), menuVisible = _a[0], setMenuVisible = _a[1];
    (0, react_1.useEffect)(function () {
        var qs = document.querySelector(":root");
        qs.style.setProperty("--primary", props.theme ? props.theme.primary : "#273B85");
        qs.style.setProperty("--primary-hover", props.theme ? props.theme.primaryHover : "#4C68CE");
        qs.style.setProperty("--dark", props.theme ? props.theme.dark : "#8197EA");
        qs.style.setProperty("--light", props.theme ? props.theme.light : "#141B4D");
        qs.style.setProperty("--emphasis", props.theme ? props.theme.emphasis : "#F29100");
    }, [props.theme]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TopBar_1.default, { onClickHamburger: props.onClickHamburger, items: props.topBarItems, right: props.topBarRight, menuVisible: menuVisible, onChangeMenuVisible: setMenuVisible, onClick: function () { return setMenuVisible(false); } }),
        react_1.default.createElement(ToolBar_1.default, { items: props.toolBarItems, right: props.toolBarRight, onClick: function () { return setMenuVisible(false); } }),
        react_1.default.createElement("div", { className: "page", onClick: function () { return setMenuVisible(false); } }, props.children)));
};
exports.default = PPLayout;
